export function formatDocDate(n) {
    if (!n) return '';
    const dt =new Date(n);
    return dt.toLocaleDateString('ru-RU');
}

export function formatTime(n) {
    if(!n) return '';
    const dt = new Date(n);
    return  dt.toLocaleTimeString('ru-RU');
}

export function formatDateTime(n) {
    if(!n) return '';
    return formatDocDate(n) + ' ' + formatTime(n)
}

export function formatAsCalendarDay(n) {
    const date = new Date(n);

    const formatted = date.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long'
    });
    return formatted
}